import React, { useEffect, useState, useRef } from 'react';
import Controls_Map_Floors from '../InteractiveMap/Controls_Map_Floors';
import Controls_Map_Selector from '../InteractiveMap/Controls_Map_Selector';
import Controls_Map_Zoom from '../InteractiveMap/Controls_Map_Zoom';
import Render_Map from '../InteractiveMap/Render_Map';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
// import { useAuth } from '../Contexts/AuthContext';




export default function Panel_Map_Center({ NoControls }) {
    // const { Account, Loading } = useAuth();
    const { Map_Composition, Refresh, Map_HighlightedMarker_Set, Selected_Building, Selected_Building_Set, Selected_Floor, Selected_Floor_Set, Transformer_Reference, Container_Reference } = useMapRenderer();


    return (
        <div className='ME_Container'>
            {NoControls ?
                <div ref={Container_Reference} className='Renderer_Map'>
                    <Render_Map
                        Map_Composition={Map_Composition}
                        Selected_Building={Selected_Building}
                        Selected_Floor={Selected_Floor}
                        Floor_Set={Selected_Floor_Set}
                    />
                </div>
                :
                <TransformWrapper
                    initialScale={!NoControls ? 1 : 0.75}
                    minScale={0.5}
                    maxScale={!NoControls ? 3 : 0.75}
                    wheel={{ disabled: NoControls }}
                    doubleClick={{ disabled: NoControls }}
                    ref={Transformer_Reference}
                >
                    {({ zoomIn, zoomOut }) => (
                        <>
                            {!NoControls ?
                                <>
                                    <Controls_Map_Selector
                                        Absolute={true}
                                        // Map_Composition={Map_Composition}
                                        // Building_Set={Selected_Building_Set}
                                        // Floor_Set={Selected_Floor_Set}
                                        // Selected_Building={Selected_Building}
                                        // Selected_Floor={Selected_Floor}
                                    />
                                    <Controls_Map_Floors
                                        Map_Composition={Map_Composition}
                                        Selected_Building={Selected_Building}
                                        Selected_Floor={Selected_Floor}
                                        Floor_Set={Selected_Floor_Set}
                                    />
                                </>
                                :
                                ""
                            }

                            {/* <Controls_Map_Zoom
                            Zoom_In={zoomIn}
                            Zoom_Out={zoomOut}
                        /> */}
                            <TransformComponent>
                                <div ref={Container_Reference} className='Renderer_Map'>
                                    <Render_Map
                                        Map_Composition={Map_Composition}
                                        Selected_Building={Selected_Building}
                                        Selected_Floor={Selected_Floor}
                                        Floor_Set={Selected_Floor_Set}
                                    />
                                </div>

                            </TransformComponent>
                        </>

                    )}
                </TransformWrapper>
            }
            
        </div>
    );

}


